"use strict";

import angular from "angular";

angular.module("nucont.accounting.groups", ["nucont.shared"]);
require("./groups.routes");
